<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { t } from "../../../../core";

  const dispatch = createEventDispatcher();

  export let expiredCaseNumber: string;
  export let newCaseNumber: string;

  $: description = t("Popup.CaseChanged.Description").replace('{oldCaseNumber}', expiredCaseNumber).replace('{newCaseNumber}', newCaseNumber)
</script>

<div class="popup">
  <h3 class="popup__title">
    {t("Popup.CaseChanged.Title")}
  </h3>
  <div class="popup__description">
    {@html description}
  </div>
  <button on:click={() => dispatch('close')} class="btn">
    {t("Popup.CaseChanged.Close")}
  </button>
</div>

<style lang="scss">
  .popup {
    background-color: $background-color;
    width: 600px;
    max-width: 100%;
    padding: 20px;
    margin: auto;

    &__title {
      @include h2;
      margin-bottom: 15px;
    }

    &__description {
      margin-bottom: 15px;
    }
  }
</style>